module.exports = __webpack_public_path__ + "img/logo7.d24d3078.png";